import React from "react";

const Music = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/2000/xlink"
    >
        <path
            fill={fill}
            d="M32 .889v23.506c0 3.71-3.016 6.716-6.737 6.716-3.72 0-6.737-3.007-6.737-6.716s3.017-6.716 6.737-6.716c1.227 0 2.378.327 3.369.899V5.926H13.474v18.47c0 3.708-3.017 6.715-6.737 6.715S0 28.104 0 24.395s3.016-6.716 6.737-6.716c1.227 0 2.377.327 3.368.899V.887H32Z"
        />
    </svg>
);

export default Music;


